import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { KeywordsService } from '../../shared/services/keywords.service';
import { MessageService } from '../../shared/services/message.service';
import { LeftSidebarComponent } from '../../shared/left-sidebar/left-sidebar.component';
import { form, FormField, FormRoot, requiredError, validate } from '@angular/forms/signals';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-send-as-client',
  standalone: true,
  imports: [LeftSidebarComponent, FormRoot, FormField],
  templateUrl: 'send-as-client.component.html',
})
export class SendAsClientComponent implements OnInit {
  private keywordsService = inject(KeywordsService);
  private messageService = inject(MessageService);

  prefixes = signal<any[]>([]);
  providerCodes = signal<any[]>([]);

  model = signal({
    prefixId: 0,
    providerCodeId: 0,
    phoneNumber: '',
    identity: '',
    providerNumber: '',
    message: '',
  });

  constructor(private toastr: ToastrService) {}

  messageForm = form(
    this.model,
    (path) => {
      validate(path.prefixId, ({ value }) => (value() === 0 ? requiredError({ message: 'Izaberi prefix' }) : undefined));
      validate(path.providerCodeId, ({ value }) =>
        value() === 0 ? requiredError({ message: 'Izaberi provider kod' }) : undefined,
      );
    },
    {
      submission: {
        action: async () => this.send(),
        onInvalid: () => this.toastr.error('Popuni sva obavezna polja'),
      },
    },
  );

  filteredProviderCodes = computed(() => {
    const prefix = this.prefixes().find((p) => p.id === this.model().prefixId);
    if (!prefix) {
      return [];
    }
    return this.providerCodes().filter((code) => code.prefix_code === prefix.prefix_code);
  });

  ngOnInit() {
    this.keywordsService.getKeywordsAndPrefixes().subscribe({
      next: (data) => {
        this.providerCodes.set(data.provider_codes);
        this.prefixes.set(data.prefixes);
      },
      error: (err) => console.error(err),
    });
  }

  updatePrefixId(event: Event) {
    const newId = Number((event.target as HTMLSelectElement).value);
    this.model.update((model) => ({ ...model, prefixId: newId, providerCodeId: 0 }));
  }

  updateProviderCodeId(event: Event) {
    const newId = Number((event.target as HTMLSelectElement).value);
    this.model.update((model) => ({ ...model, providerCodeId: newId }));
  }

  send() {
    const { phoneNumber, identity, providerCodeId, providerNumber, message } = this.model();
    this.messageService
      .sendMessageAsClient(phoneNumber, identity, providerCodeId, Number(providerNumber), message)
      .subscribe({
        next: () => {
          this.toastr.success('Poruka poslata kao klijent');
          this.model.set({
            prefixId: 0,
            providerCodeId: 0,
            phoneNumber: '',
            identity: '',
            providerNumber: '',
            message: '',
          });
          this.messageForm().reset();
        },
        error: () => this.toastr.error('Došlo je do greške'),
      });
  }
}
